import React from "react";
import "./PasswordRequirements.css";

const PasswordRequirements = ({
  checks,
  id,
}: {
  checks: {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasDigit: boolean;
    hasSpecial: boolean;
  };
  id: string;
}) => {
  const mapped = [
    { met: checks.minLength, label: "8+ characters" },
    { met: checks.hasUppercase, label: "Uppercase" },
    { met: checks.hasLowercase, label: "Lowercase" },
    { met: checks.hasDigit, label: "Number" },
    { met: checks.hasSpecial, label: "Special character" },
  ];

  return (
    <ul id={id} className="password-requirements" aria-live="polite" aria-label="Password requirements">
      {mapped.map((rule, idx) => (
        <li
          key={idx}
          className={`password-requirements__item${rule.met ? " password-requirements__item--met" : ""}`}
        >
          <span className="password-requirements__tick" aria-hidden="true">{rule.met ? "✓" : "○"}</span>
          {rule.label}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;